const ICON_SHAPES = Object.freeze({
  lock: Object.freeze([
    ["rect", { x: "5", y: "10", width: "14", height: "10", rx: "2" }],
    ["path", { d: "M8 10V7a4 4 0 0 1 8 0v3" }]
  ]),
  unlock: Object.freeze([
    ["rect", { x: "5", y: "10", width: "14", height: "10", rx: "2" }],
    ["path", { d: "M8 10V7a4 4 0 0 1 7.5-2" }]
  ]),
  clone: Object.freeze([
    ["rect", { x: "8", y: "8", width: "11", height: "11", rx: "2" }],
    ["path", { d: "M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" }]
  ]),
  copy: Object.freeze([
    ["rect", { x: "9", y: "9", width: "11", height: "11", rx: "2" }],
    ["path", { d: "M15 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h3" }]
  ]),
  opacity: Object.freeze([
    ["path", { d: "M12 3.5S6.5 9.7 6.5 14a5.5 5.5 0 0 0 11 0C17.5 9.7 12 3.5 12 3.5Z" }],
    ["path", { d: "M9.3 15.2a3 3 0 0 0 2.7 1.7" }]
  ]),
  trash: Object.freeze([
    ["path", { d: "M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5" }]
  ]),
  alert: Object.freeze([
    ["path", { d: "M6 16.5h12l-1.4-2V10a4.6 4.6 0 0 0-9.2 0v4.5L6 16.5Z" }],
    ["path", { d: "M10 19h4" }]
  ]),
  settings: Object.freeze([
    ["circle", { cx: "12", cy: "12", r: "3" }],
    ["path", { d: "M19 13.5v-3l-2-.7-.7-1.7.9-1.9-2.1-2.1-1.9.9-1.7-.7-.7-2h-3l-.7 2-1.7.7-1.9-.9-2.1 2.1.9 1.9-.7 1.7-2 .7v3l2 .7.7 1.7-.9 1.9 2.1 2.1 1.9-.9 1.7.7.7 2h3l.7-2 1.7-.7 1.9.9 2.1-2.1-.9-1.9.7-1.7 2-.7Z" }]
  ]),
  objectSettings: Object.freeze([
    ["path", { d: "M4 7h7.7M16.3 7H20M4 17h3.7M12.3 17H20" }],
    ["circle", { cx: "14", cy: "7", r: "2.3" }],
    ["circle", { cx: "10", cy: "17", r: "2.3" }]
  ]),
  objectTrash: Object.freeze([
    ["path", { d: "M5 7h14M9 7V4.5h6V7" }],
    ["path", { d: "m7.3 7.6.8 10.9a1.5 1.5 0 0 0 1.5 1.4h4.8a1.5 1.5 0 0 0 1.5-1.4l.8-10.9" }],
    ["path", { d: "M10.2 11v5.4M13.8 11v5.4" }]
  ]),
  more: Object.freeze([
    ["circle", { cx: "5", cy: "12", r: "1.6", fill: "currentColor", stroke: "none" }],
    ["circle", { cx: "12", cy: "12", r: "1.6", fill: "currentColor", stroke: "none" }],
    ["circle", { cx: "19", cy: "12", r: "1.6", fill: "currentColor", stroke: "none" }]
  ])
});

export function createChartIcon(name, documentRef = document) {
  const shapes = ICON_SHAPES[name];
  if (!shapes) return null;
  const namespace = "http://www.w3.org/2000/svg";
  const svg = documentRef.createElementNS(namespace, "svg");
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("aria-hidden", "true");
  svg.dataset.chartIcon = name;
  for (const [tag, attributes] of shapes) {
    const shape = documentRef.createElementNS(namespace, tag);
    for (const [attribute, value] of Object.entries(attributes)) {
      shape.setAttribute(attribute, value);
    }
    svg.append(shape);
  }
  return svg;
}
